module.exports = __webpack_public_path__ + "static/media/morganitedp.ebea882b.jpg";